import { usePatchTask, type TaskDto } from '../../api/tasks';
import { DatePicker } from '../DatePicker';

export function DueEditor({ task, onClose }: { task: TaskDto; onClose: () => void }) {
  const patch = usePatchTask();
  return (
    <DatePicker
      label="Due"
      value={task.dueAt}
      onPick={(iso) => {
        patch.mutate({ id: task.id, patch: { dueAt: iso } });
        onClose();
      }}
    />
  );
}
